import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import { ArrowRight, BookOpen } from "lucide-react";

/**
 * Top ribbon — cross-promotion to the sister blog-magazine
 * `solteseufrances.com.br`. Always visible above the header. Designed to be
 * discrete: single-line, tasteful, brand-aligned typography — not a
 * promotional loud strip.
 *
 * Adds a DoFollow external link (SEO benefit for the sister project).
 */
const COPY = {
  pt: {
    label: "Blog-magazine",
    text: "Também escrevo semanalmente para brasileiros aprenderem francês em",
    linkText: "solteseufrances.com.br",
    cta: "Ler agora",
  },
  en: {
    label: "Sister blog",
    text: "I also write weekly for Brazilians learning French at",
    linkText: "solteseufrances.com.br",
    cta: "Read now",
  },
  fr: {
    label: "Blog-magazine",
    text: "J'écris aussi chaque semaine pour les Brésiliens qui apprennent le français sur",
    linkText: "solteseufrances.com.br",
    cta: "Lire",
  },
};

const TopRibbon = () => {
  const { lang } = useLanguage();
  const t = COPY[lang] || COPY.pt;

  return (
    <div
      data-testid="top-ribbon"
      className="fixed top-0 left-0 right-0 z-[60] w-full bg-gradient-to-r from-[#1e2a5a] via-[#243070] to-[#1e2a5a] text-[#f4f1ea] border-b border-[#d9381e]/40 shadow-sm"
    >
      <div className="max-w-7xl mx-auto px-3 sm:px-10 lg:px-12 h-11 sm:h-12 flex items-center justify-center gap-2 sm:gap-3 text-[12px] sm:text-sm overflow-hidden">
        <span className="inline-flex items-center gap-1.5 uppercase tracking-[0.18em] text-[10px] sm:text-xs font-semibold text-[#f4f1ea] bg-[#d9381e] px-2 py-0.5 sm:px-2.5 sm:py-1 rounded-full shrink-0">
          <span className="relative flex h-1.5 w-1.5">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#f4f1ea] opacity-75" />
            <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-[#f4f1ea]" />
          </span>
          <BookOpen className="h-3 w-3 sm:h-3.5 sm:w-3.5" strokeWidth={2.25} />
          {t.label}
        </span>
        <span className="text-[#f4f1ea]/95 font-medium truncate">
          {t.text}{" "}
          <a
            href="https://solteseufrances.com.br"
            target="_blank"
            rel="noopener"
            data-testid="top-ribbon-link"
            className="group inline-flex items-center gap-1 text-[#e5b3b3] font-semibold underline underline-offset-4 decoration-[#d9381e] decoration-2 hover:text-[#d9381e] hover:decoration-[#f4f1ea] transition-colors"
          >
            {t.linkText}
            <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-1" strokeWidth={2.25} />
          </a>
        </span>
      </div>
    </div>
  );
};

export default TopRibbon;
